import React from 'react';
import clsx from 'clsx';

export default function Container({ children, className, ...props }) {
  return (
    <div className={clsx('px-4 lg:px-16', className)} {...props}>
      {children}
    </div>
  );
}
